export const SLUG_SEPARATOR = '+';



// WEBPACK FOOTER //
// ./src/components/download/const/index.js